import React, { useContext, useEffect, useState } from "react";
import { TwoColumn, TwoRow } from "../../core/layouts";
import { Text } from "react_reusable_components";
import useResponsive from "../../core/hooks/useResponsive";
import variables from "../../themes/base/styles/variables";
import { useIntl } from "react-intl";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import MediaService from "../../services/media-service";

const viewUserDetailsImagesStyle = {
  imagePreviewIconStyle: {
    width: "3.75rem",
    height: "3.75rem",
    objectFit: "cover",
  },
  imagePreviewContainer: {
    background: variables.whiteSmoke,
    border: `1px solid ${variables.grey4}`,
    marginTop: variables.marginSmallest,
    padding: variables.paddingSmall2,
    overflow: "none",
    width: "100%",
  },
  uploadImageTextStyle: {
    fontSize: variables.fontSizeNormal,
    fontWeight: variables.fontWeightBold,
    lineHeight: variables.lineHeightNormal,
    color: variables.textDefault,
  },
  twoColumnContainerStyle: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    gap: variables.gapSmaller,
  },
  fileNameStyle: {
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightNormal,
    color: variables.textDefault,
  },
  fileSizeStyle: {
    fontSize: variables.fontSizeSmallest,
    lineHeight: variables.lineHeightMedium,
    color: variables.grey2,
    marginTop: "0.25rem",
  },
  imagePreviewContainerStyle: {
    marginTop: variables.marginMediumLarge,
  },
};

export default function ViewUserDetailsImageContainer({ userData }) {
  const loaderDispatch = useContext(GlobalLoaderContext)[1];
  const [imageUrl, setImageUrl] = useState("");
  const [imageSize, setImageSize] = useState("");
  const [imageName, setImageName] = useState("");
  const responsive = useResponsive();
  const intl = useIntl();

  useEffect(() => {
    if (userData?.imageId) {
      MediaService?.getMediaData({
        loaderDispatch,
        mediaId: userData?.imageId,
        intl,
      }).then((res) => {
        let filename =
          res?.headers["content-disposition"].split("filename=")[1];
        filename = filename.replace(/['"]+/g, "");
        var url = URL.createObjectURL(res?.data);
        setImageName(filename);
        setImageUrl(url);
        setImageSize(res?.data?.size);
      });
    }
  }, [intl, userData?.imageId]);

  const bytesToMB = (bytes) => {
    return bytes / (1024 * 1024);
  };

  return (
    <TwoRow
      style={viewUserDetailsImagesStyle.imagePreviewContainerStyle}
      topSection={
        <Text style={viewUserDetailsImagesStyle.uploadImageTextStyle}>
          {getLocalizedMessage(intl, "viewUser.details.image")}
        </Text>
      }
      bottomSection={
        <TwoColumn
          style={viewUserDetailsImagesStyle.twoColumnContainerStyle}
          leftSection={
            imageUrl && (
              <img
                src={imageUrl}
                style={viewUserDetailsImagesStyle.imagePreviewIconStyle}
                alt="Selected"
                crossorigin="anonymous"
                loading="lazy"
              />
            )
          }
          rightSection={
            <TwoRow
              topSection={
                <Text style={viewUserDetailsImagesStyle.fileNameStyle}>
                  {imageName}
                </Text>
              }
              bottomSection={
                <Text style={viewUserDetailsImagesStyle.fileSizeStyle}>
                  {bytesToMB(imageSize).toFixed(3) + " MB"}
                </Text>
              }
            />
          }
          middleSectionStyle={viewUserDetailsImagesStyle.middleSectionStyle}
        />
      }
      bottomSectionStyle={{
        ...viewUserDetailsImagesStyle.imagePreviewContainer,
        ...(responsive.isMd && { width: "fit-content" }),
      }}
    />
  );
}
